import { ToastService } from './../../../servicios/toast.service';
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-toast-informativo',
  templateUrl: './toast-informativo.component.html',
  styleUrls: ['./toast-informativo.component.scss']
})
export class ToastInformativoComponent implements OnInit {

  public mensaje: string;
  public activo: boolean;

  constructor(private toastService: ToastService) { }

  ngOnInit() {
    this.mensaje = this.toastService.mensaje.value;
    this.activo = this.toastService.activo.value;

    this.toastService.mensaje.subscribe(nuevoMensaje => this.mensaje = nuevoMensaje);
    this.toastService.activo.subscribe(nuevoActivo => this.activo = nuevoActivo);
  }

  public cerrarToast(): void {
    this.toastService.ocultarToast();
  }
}
